export const fieldTranslations = {
  // Fields for transaction
  date: "Date de la transaction",
  a6_portfolio_name: "Compte",
  a6_static_datum_name: "Actif",
  market_value_ptf_ccy: "Montant en devise de reporting",
  market_value_local_ccy: "Montant en devise locale",
  quantity: "Quantité",
  transfer: "Type de transfert",
  category: "Type de mouvement",
  description: "Description du mouvement",

  // Fees fields
  fee_currency: "Devise du frais",
  broker_fee: "Frais de courtage",
  custodian_broker_fee: "Frais de courtage dépositaire",
  other_fee: "Autres frais",
  fees: "Total des frais",
  fee_type: "Type de frais",

  // Technical fields
  a6_portfolio_id: "ID du portefeuille",
  a6_static_datum_id: "ID de l'actif",
  a6_portfolio_account_type: "Type de compte",
  a6_static_datum_asset_class_1: "Classe d'actif principale",
  a6_static_datum_asset_class_2: "Sous-classe d'actif",
  a6_portfolio_currency: "Devise du portefeuille",
  a6_static_datum_currency: "Devise de l'actif",
  created_at: "Créé le",
  updated_at: "Mis à jour le",
  time_serie_file_id: "ID du fichier de série temporelle",
};
